import commonObj from 'commonObj';

export default function addToken(value) {
  try {
    const parsedUrl = new URL(value);

    if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
      return value;
    }

    if (parsedUrl.host !== 'changba.com' && !/\.changbaops\.com$/.test(parsedUrl.host)) {
      return value;
    }

    if (!commonObj.data.userid || !commonObj.data.token) {
      return value;
    }

    parsedUrl.searchParams.set('curuserid', commonObj.data.userid);
    parsedUrl.searchParams.set('token', commonObj.data.token);

    return parsedUrl.href;
  }
  catch (e) {
    return value;
  }
}
